module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapterno"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('b', [_vm._v("2")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "chapter"
  }, [_vm._v("GET PAID FOR YOUR INFORMATION.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The late Aaron Swartz, who co-created the RSS Web feed system when he was only 14, believed that in the Internet age there should be no need for anyone to pay for the information they want.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Information is power,” said Swartz. “But like all power, there are those who want to keep it for themselves.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I don’t want to keep my information for myself. But given the time and cost required to create my publications, aren’t I entitled — just like any other working stiff — to be compensated for my labors?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The world’s entire scientific and cultural heritage, published over centuries in books and journals, is increasingly being digitized and locked up by a handful of private corporations,” Swartz wrote.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By “a handful of private corporations” I think he means publishers and other content producers. Publishing is a for-profit business, like any other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sharing isn’t immoral,” Swartz continued. “It’s a moral imperative.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("In every case? I don’t believe the U.S., for example, willingly shares its military secrets with its adversaries.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Nor do competitors within an industry share all their trade secrets with one another. Are they morally corrupt not to do so?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Swartz concluded: “Only those blinded by greed would refuse to let a friend make a copy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I don’t consider myself greedy, but I do not allow my customers to copy my e-books and give away those copies to their friends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That would be a copyright violation; they would be stealing from me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If their friends want my e-book, they can pay the same $29 per copy everyone else does.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Internet has encouraged what author Harlan Ellison told me is a “slacker mentality.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It has also caused more people to take the position that all information should be free — which conversely and necessarily means authors and other content creators shouldn’t be paid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I find this position patently absurd.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one expects her dentist to fill her cavities for free … or her dry cleaner to press her skirts and pants without charge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So why should writers, designers, programmers, composers, and other content creators be required to work for free — and give up any chance of making a living from their craft?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is unfair. It makes no sense, Swartz to the contrary. In America, in a free market, workers get paid for their labor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Already, the Internet has created a marketplace where content writers in particular are expected to work for peanuts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A recent article in The New York Review of Books stated that the average Mexican journalist gets paid a paltry $5 per article!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I started freelancing in the early 1980s, the going rate for article writing was $1 a word.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How can you survive as an author or content creator in the “information should be free” Internet mindset?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here are my suggestions:")])]), _c('p', {
    staticClass: "listt"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("1.   Do not become a commodity writer. If a thousand other writers could write the piece you are working on approximately as well as you can, you are a commodity writer.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "list"
  }, [_vm._v("2.   Those most in danger of being commodity writers are content authors who are generalists — that is, they write about a broad range of topics, moving from subject to subject based on their mood and the jobs available.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("3.   You can increase your worth in the market by specializing in a niche. That specialization can be by medium (e.g., Web sites), audience (e.g., writing for baby boomers), or subject (e.g., writing about oil and gas exploration).")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("4.   The narrower and more specialized your niche, the easier time you will have getting work and the more you will be paid.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("5.   Focus on writing projects whose purpose is to generate leads or sales for your client; e.g., e-mail marketing, direct mail, landing pages, banner ads. Reason: clients whose projects generate leads or sales view writing as a profit center, not a cost center.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("6.   You can maximize your compensation when you handle assignments where the increased revenues your sales copy generates can be precisely measured. That way, the value of your copy is beyond dispute.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("7.   Create an overwhelming demand for your writing services through proactive marketing that generates inquiries and self-promotion that establishes you as an expert in your niche.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103237b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/11_ch2.vue
// module id = 87
// module chunks = 0